import styles from './FJMediaLibraryInfoView.module.less';
import FJModalClose from '../FJModalClose/FJModalClose.jsx';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import useLocalStore from '../../../hooks/useLocalStore.js';

const Item = props => {
    const { name, url, stateText = '' } = props;
    return (
        <div className={styles.item_box}>
            <div className={styles.img_box}>
                <img src={url} />
            </div>
            <div className={styles.name}>{name}</div>
            <div className={styles.state}>{stateText}</div>
        </div>
    );
};

const FJMediaLibraryInfoView = props => {
    useLocalStore();
    const { list, onClose } = props;
    const _renderList = () => {
        return list.map((item, index) => {
            const { status, info } = item;
            const stateText = status === 'exist' ? 'ai-tool-media-existed' : 'add-failed';
            return (
                <Item key={info.name + index} name={info.name} url={info.url} stateText={FJLocalStore._(stateText)} />
            );
        });
    };

    return (
        <div className={styles.box}>
            <FJModalClose onClick={onClose} />
            <div className={styles.header_title}>{FJLocalStore._('an-error-occurred')}</div>
            <div className={styles.desc_title}>{FJLocalStore._('ai-failed-to-add-download-reason-check')}</div>
            <div className={styles.scroller_box}>
                <FJVerticalScroller>
                    <div className={styles.view}>{_renderList()}</div>
                </FJVerticalScroller>
            </div>
            <div className={styles.btn_box}>
                <FJButton type={'orange'} className={styles.ok_bt} text={FJLocalStore._('ok')} onClick={onClose} />
            </div>
        </div>
    );
};

FJMediaLibraryInfoView.propTypes = {
    list: PropTypes.array,
    onClose: PropTypes.func,
};

Item.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    stateText: PropTypes.string,
};

export default FJMediaLibraryInfoView;
